// extracted by mini-css-extract-plugin
module.exports = {"seatChangeTableWrap":"eJOrD","scTableRow":"XHd92","tableHead":"WtZ1B","scTableCol":"RAf2N","partyLogo":"ppebK","red":"Hahns","green":"e9lG_","partyNameStatus":"Nca9j"};